import { render, staticRenderFns } from "./BlockBasic.vue?vue&type=template&id=1fc56cfe&scoped=true&"
import script from "./BlockBasic.vue?vue&type=script&lang=js&"
export * from "./BlockBasic.vue?vue&type=script&lang=js&"
import style0 from "./BlockBasic.vue?vue&type=style&index=0&id=1fc56cfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc56cfe",
  null
  
)

export default component.exports